import React from 'react'
import { LoaderContainer } from './ItemLoader.css';
import { useShoppingCartContext } from '../../../providers/ShoppingCartProvider';

interface ItemLoaderProps {
  showLoader: boolean
  itemProductIdBeingUpdated?: string | null
  currentItemProductId?: string | null
}

const LoaderIcon = () => (
  <svg
    className="loader-icon"
    width="60"
    height="60"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="loader-icon"
  >
    <circle cx="12" cy="12" r="10" stroke="#C4C4C4" strokeWidth="4" />
    <path d="M22 12C22 17.5228 17.5228 22 12 22" stroke="#3A3A3A" strokeWidth="4" strokeLinecap="round" />
  </svg>
)

export const ItemLoader = ({
  showLoader,
  currentItemProductId,
}: ItemLoaderProps) => {
  if (!showLoader) return null;

  const { itemProductIdBeingUpdated } = useShoppingCartContext()

  return (
    <LoaderContainer>
      {itemProductIdBeingUpdated === currentItemProductId && (
        <LoaderIcon />
      )}
    </LoaderContainer>
  )
}
